(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["link-list"] && !Shopify.designMode) return;
  try {
    const narrow = matchMedia('(max-width: 700px)');
  const setOpen = (list, open) => {
    list.toggleAttribute('data-collapsed', !open);
    list.querySelector('[data-link-list-toggle]')?.setAttribute('aria-expanded', String(open));
  };
  const sync = () => document.querySelectorAll('.link-list').forEach((list) => setOpen(list, !narrow.matches));
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-link-list-toggle]');
    if (toggle && narrow.matches) setOpen(toggle.closest('.link-list'), toggle.getAttribute('aria-expanded') !== 'true');
  });
  narrow.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
  sync();
  } catch(e) { console.error(e); }
})();

})();
